import React from "react";
import { Link } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";

const Manifesto = () => {
  return (
    <SectionLayout>
      <h2 className="glass-panel__title" data-testid="section-title">
        MANIFESTO
      </h2>
      <p className="glass-panel__body" data-testid="section-body">
        We exist in an era of infinite, commoditized automation, where the
        digital landscape is rapidly submerging under a flood of robotic
        copy, generic design, and systems that feel entirely devoid of a
        pulse. In a paradigm where anyone can generate a million words in a
        fraction of a second, sheer volume has ceased to be an advantage.
        The true scarcity — and therefore the ultimate value — lies in the
        ability to generate a genuine feeling.
      </p>
      <p className="glass-panel__body">
        Pandurata was founded upon a singular, unyielding engineering
        principle: technology must serve to scale humanity, never to
        replace it. While we operate as an applied artificial intelligence
        consultancy, our ultimate obsession is not with the machines
        themselves, but with the profound nuances of human intuition and
        the undeniable power of having genuine taste.
      </p>
      <p className="glass-panel__body">
        We understand that a premium brand operates as a carefully curated
        fantasy, and that illusion requires an ironclad infrastructure to
        survive at scale. If the internal operations are chaotic, the
        external magic inevitably shatters. Therefore, we do not build
        cold, off-the-shelf software; we engineer digital nervous systems
        that actually breathe. We design the structural architecture that
        absorbs the heavy, brutal lifting of your logistics and workflows,
        freeing your business to remain entirely focused on the art, the
        strategy, and the human connection that renders it unique.
      </p>
      <p className="glass-panel__body">
        Efficiency without a grounding aesthetic is nothing more than a
        factory. We firmly believe that how a system looks, feels, and
        communicates is just as critical to its survival as how fast it
        computes. Design is not a superficial cosmetic choice; it is the
        fundamental difference between a mechanical transaction and a
        lasting, immersive experience.
      </p>
      <p className="glass-panel__body">
        Taste is the ultimate protective moat. Narrative is the true asset.
        Technology is merely the lever we use to grant high-end operators
        the scale of the future, while fiercely protecting the analog soul
        that makes them impossible to replicate.
      </p>
      <div className="glass-panel__nav">
        <Link to="/" className="glass-panel__btn" data-testid="btn-home">
          Home
        </Link>
        <Link
          to="/architecture"
          className="glass-panel__btn glass-panel__btn--right"
          data-testid="btn-next"
        >
          Architecture
        </Link>
      </div>
    </SectionLayout>
  );
};

export default Manifesto;
